module.exports = __webpack_public_path__ + "d545ea7356ed04e5bfa0b1a3a35dfb31.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/skyfell.png
// module id = 440
// module chunks = 0